import JoinContainer from 'components/Join/JoinContainer'
import JoinPresentation from 'components/Join/JoinPresentation'
import JoinData from 'components/Join/JoinData'
export default {
  Container: JoinContainer,
  Presentation: JoinPresentation,
  Data: JoinData,
}
